const STORAGE_KEY = 'font_size_scale';

const SCALE_VALUES = {
  small: 0.85,
  medium: 1,
  large: 1.34,
};

export function getFontScale() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SCALE_VALUES[stored] !== undefined) return stored;
  } catch (_) { /* ignore */ }
  return 'medium';
}

export function getFontScaleValue() {
  return SCALE_VALUES[getFontScale()] || 1;
}

export function applyFontScale(size) {
  const value = SCALE_VALUES[size];
  if (value === undefined) return;
  localStorage.setItem(STORAGE_KEY, size);
  document.documentElement.style.setProperty('--font-scale', String(value));
}

export function initFontScale() {
  applyFontScale(getFontScale());
}
